//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['portfolio_entry', 'archive_link', 'next_entry', 'previous_entry'],
    data() {
        return {
            index: 0,
            numberOfImages: this.portfolio_entry.galerie.length,
            interval: setInterval(() => this.increaseIndex(), 2500)
        };
    },
    methods: {
        increaseIndex() {
            if (this.index >= this.numberOfImages - 1) {
                this.index = 0;
            } else {
                this.index++;
            }
            clearInterval(this.interval);
            this.interval = setInterval(() => this.increaseIndex(), 2500);
        },
        decreaseIndex() {
            if (this.index <= 0) {
                this.index = this.numberOfImages - 1;
            } else {
                this.index--;
            }
            clearInterval(this.interval);
            this.interval = setInterval(() => this.increaseIndex(), 2500);
        }
    },
    mounted() {
        $('body').addClass('gray-background');
        let slider = $('.single-portfolio');
        // Swipe
        slider.hammer().on('swipeleft', () => this.increaseIndex());
        slider.hammer().on('swiperight', () => this.decreaseIndex());
    }
}



// WEBPACK FOOTER //
// ./scripts/vue/single-portfolio.vue